// Which messengers can import whole-account history.
//
// Must stay in step with HISTORY_CAPABLE_MESSENGERS in src/app/admin/routes.py
// and with the `case "load_history"` handler, which exists only inside
// startTelegramWorker. Three places, and the panel's copy was a bare string
// comparison — so adding a messenger to the backend left the only button
// that starts a backfill hidden, with nothing failing to say why.
export const HISTORY_CAPABLE_MESSENGERS = ['telegram'];

export function canImportHistory(session) {
  return HISTORY_CAPABLE_MESSENGERS.includes(
    String(session?.messenger_type || '').toLowerCase()
  );
}
